import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { withStyles, Grid } from '@material-ui/core';
import { FHEItemText } from 'data/components';
import { updateProductField } from '../../../../../../data/Products/actions';

class SDM18HCLDetail extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        operatingMode: PropTypes.string,
        planningMode: PropTypes.string,
        climMode: PropTypes.string,
        climState: PropTypes.string,
        relayState: PropTypes.string,
        remoteRef: PropTypes.string
    };

    static defaultProps = {
        operatingMode: null,
        planningMode: null,
        climMode: null,
        climState: null,
        relayState: false,
        remoteRef: null
    };

    render() {
        const { classes, operatingMode, planningMode, climMode, climState, relayState, remoteRef } = this.props;
        return (
            <React.Fragment>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.operatingMode')}
                        itemContent={Translator.translate(`general.productModules.${operatingMode}`)}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.climState')}
                        itemContent={climState}
                        classContent={climState === 'OFF' ? classes.offColor : classes.onColor}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.relayState')}
                        itemContent={relayState}
                        classContent={relayState === 'OFF' ? classes.offColor : classes.onColor}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.planningMode')}
                        itemContent={Translator.translate(`general.productModules.${planningMode}`)}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.climMode')}
                        itemContent={Translator.translate(`general.table.data.${climMode}`)}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText itemTitle={Translator.translate('general.table.column.remoteRef')} itemContent={remoteRef} />
                </Grid>
            </React.Fragment>
        );
    }
}
function mapStateToProps(state, props) {
    const productKey = props.productKey;
    const product = state.environments.fhe.data.Products.getIn(['list', productKey], new Map());
    return {
        profile: state.data.user,
        productKey: productKey,
        productType: product.get('productType'),
        type: product.get('type'),
        operatingMode: product.get('operatingMode'),
        planningMode: product.get('planningMode'),
        relayState: product.get('relayState'),
        climMode: product.get('climMode'),
        climState: product.get('climState'),
        remoteRef: product.get('remoteRef')
    };
}

const styles = theme => ({
    onColor: {
        color: theme.palette.success.main
    },
    offColor: {
        color: theme.palette.error.main
    }
});
export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ updateProductField }, dispatch)
    )(withStyles(styles, { withTheme: true })(SDM18HCLDetail))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/Product/HeatAndCool/SDM18HCL/index.js